import { Phone, Mail } from "lucide-react";
import { BUSINESS } from "../data/site";

export const StickyBar = ({ label = "24/7 Dispatch — We Answer" }) => (
  <div
    data-testid="sticky-contact-bar"
    className="fixed bottom-0 left-0 right-0 z-50 bg-[#121316]/95 backdrop-blur-md border-t border-[#FF9100]/25 py-2.5 px-4 shadow-[0_-8px_30px_rgba(0,0,0,0.6)]"
  >
    <div className="max-w-7xl mx-auto flex items-center justify-between gap-3">
      <div className="hidden sm:flex items-center gap-2">
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-60"></span>
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500"></span>
        </span>
        <span className="text-xs font-semibold text-gray-300 tracking-wide" data-testid="sticky-24-7-badge">{label}</span>
      </div>
      <div className="flex flex-1 sm:flex-none items-center justify-center gap-2 sm:gap-3">
        <a
          href={BUSINESS.phoneHref}
          data-testid="sticky-phone-btn"
          className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 bg-[#FF9100] hover:bg-[#FF5500] text-[#0D0E11] font-bold text-xs sm:text-sm whitespace-nowrap px-3 sm:px-5 py-2.5 rounded-full transition-colors duration-200"
        >
          <Phone className="w-4 h-4" />
          <span>{BUSINESS.phone}</span>
        </a>
        <a
          href={BUSINESS.emailHref}
          data-testid="sticky-email-btn"
          className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 border border-[#FF9100]/50 hover:border-[#FF9100] hover:bg-[#FF9100]/10 text-[#FF9100] font-semibold text-xs sm:text-sm px-4 sm:px-5 py-2.5 rounded-full transition-colors duration-200"
        >
          <Mail className="w-4 h-4" />
          <span className="truncate">{BUSINESS.email}</span>
        </a>
      </div>
    </div>
  </div>
);
